import React from 'react';
import {useIntl} from 'react-intl';

import {useLocalesMgr} from 'coreHooks';

import messages from 'brand/app/pages/store-locator/messages';
import Icon from 'brandComponents/Icon';
import Link from 'brandComponents/Link';
import Typography from 'brandComponents/Typography';

import {IStoreCardProps} from './IStoreCard';

import styles from './StoreCard.module.scss';

const StoreCard = ({store}: IStoreCardProps) => {
	const intl = useIntl();
	const localesMgr = useLocalesMgr();
	const link = store.isEnabledMoreDetailsLink
		? localesMgr.updateLinkWithLocale(`/store-detail?StoreID=${store.ID}`)
		: null;

	return (
		<div className={styles['store-card']}>
			{store.name && (
				<Typography variant="p" classNames={styles['store-card__title']}>
					<Icon name="store-casadei" height={20} width={20} />
					{store.name}
				</Typography>
			)}

			<div className="store-card__address">
				{(store.address1 || store.address2) && (
					<Typography variant="p">{`${store.address1} ${store.address2 || ''}`}</Typography>
				)}
				{(store.city || store.countryCode) && (
					<Typography variant="p">{`${store.city} (${store.countryCode})`}</Typography>
				)}
			</div>

			<div className={styles['store-card__actions']}>
				<div className={styles['store-car__actions__contacts']}>
					{store.phone && (
						<div className={styles['store-card__actions__contacts__tel']}>
							<a href={`tel:${store.phone}`}>{store.phone}</a>
						</div>
					)}
				</div>

				{link && <Link to={link}>{intl.formatMessage(messages.moreDetails)}</Link>}
			</div>
		</div>
	);
};

export default StoreCard;
